import React, { useState } from "react";
import Header from "../Sub/Header";
import Footer from "../Sub/Footer";

const InvestmentCalculator = () => {
  const [investment, setInvestment] = useState(25000);
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(10);

  const totalValue = Math.round(investment * Math.pow(1 + rate / 100, years));
  const returns = totalValue - investment;

  const investedPercentage = (investment / totalValue) * 100;
  const returnsPercentage = 100 - investedPercentage;

  return (
    <>
     <Header />
     <h2 className="text-center">Mutual Fund Returns Calculator</h2>
    <div className="calculator-container">
      <div className="left-panel">
        <div className="input-group">
          <label>Total investment (₹)</label>
          <input
            type="range"
            min="1000"
            max="100000"
            value={investment}
            onChange={(e) => setInvestment(+e.target.value)}
          />
          <input
            type="number"
            value={investment}
           
            maxLength={10}
            pattern="\d*"
            inputMode="numeric"
            onChange={(e) => setInvestment(+e.target.value)}
          />
        </div>

        <div className="input-group">
          <label>Expected return rate (% p.a.)</label>
          <input
            type="range"
            min="1"
            max="30"
            value={rate}
            onChange={(e) => setRate(+e.target.value)}
          />
          <input
            type="number"
            value={rate}
            onChange={(e) => setRate(+e.target.value)}
          />
        </div>

        <div className="input-group">
          <label>Time period (Yr)</label>
          <input
            type="range"
            min="1"
            max="30"
            value={years}
            onChange={(e) => setYears(+e.target.value)}
          />
          <input
            type="number"
            value={years}
            onChange={(e) => setYears(+e.target.value)}
          />
        </div>

        <div className="results">
          <div>
            <p>Invested amount</p>
            <h3>₹{investment.toLocaleString()}</h3>
          </div>
          <div>
            <p>Est. returns</p>
            <h3>₹{returns.toLocaleString()}</h3>
          </div>
          <div>
            <p>Total value</p>
            <h3 className="green">₹{totalValue.toLocaleString()}</h3>
          </div>
        </div>
      </div>

      <div className="right-panel">
        <div className="donut-chart">
          <svg width="160" height="160" viewBox="0 0 36 36">
            <circle
              className="circle-bg"
              cx="18"
              cy="18"
              r="15.9155"
              fill="none"
              stroke="#edefff"
              strokeWidth="4"
            />
            <circle
              className="circle"
              cx="18"
              cy="18"
              r="15.9155"
              fill="none"
              stroke="#0057b8"
              strokeWidth="4"
              strokeDasharray={`${returnsPercentage} ${investedPercentage}`}
              strokeDashoffset="25"
            />
          </svg>
        </div>

        <div className="legend">
          <div><span className="legend-color invested" /> Invested amount</div>
          <div><span className="legend-color returns" /> Est. returns</div>
        </div>

        <button className="invest-button">Invest now</button>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default InvestmentCalculator;
